window.infiniteScrollEnd = false;

$('body').on('click', '#toggle-filters', function () {
    let isOpen = $(this).attr('data-open');
    let filtersBar = $('#filters-bar');
    let searchContainer = $('.banner-tab-btn');

    filtersBar.toggleClass('d-none');
    searchContainer.toggleClass('bg-white');
})

$('body').on('click', '.category_btn_main', function () {
    $('.category_btn_main').removeClass('selected');
    $(this).addClass('selected');
    let selectCategoryID = $('#map-search-form').find('select[name="category_id"]');
    selectCategoryID.val($(this).attr('data-id'));
    selectCategoryID.trigger('change');
})

$('body').on('change', '#map-search-form select', function () {
    $('#map-search-form button#search-btn').click();
})

if ($('.map-content-sidebar').attr('data-scrollable') === 'false') {
    $(window).scroll(function () {
        let totalHeight = $('.map-content-sidebar').height() + $('.map-content-sidebar').offset().top;
        if ($(window).scrollTop() + $(window).height() >= ($(document).height() - totalHeight) && window.infiniteScrollEnd === false) {
            loadMoreItems($('.map-content-sidebar'));
        }
    });
}


window.highlightHomepageCategories = function highlightHomepageCategories(val) {
    $('.special_category_filters').addClass('d-none');
    $('.special_category_filter_' + val).removeClass('d-none');
    $('.category_btn_main').removeClass('selected');
    $(".category_btn_main[data-id='" + val + "']").addClass('selected');
}

$('body').on('change', '.map-search-form-without-map select#search_category_id', function () {
    highlightHomepageCategories($(this).val());
});

window.loadMoreItems = function loadMoreItems(el, clearAll = false, forcePage = false) {
    if (window.loadMoreItemsProcessing !== 'undefined' && window.loadMoreItemsProcessing === true) {
        return;
    }
    window.loadMoreItemsProcessing = true;
    let el2 = $('#map-content-sidebar');
    let formData = {};
    if (forcePage === false) {
        el2.attr('data-page', parseInt(el2.attr('data-page')) + 1)
    } else {
        el2.attr('data-page', 1);
    }
    formData['page'] = el2.attr('data-page');
    formData['returnHTML'] = true;
    $('#map-search-form').find('select, input').each(function () {
        formData[$(this).attr('name')] = $(this).val();
    });

    $.ajax({
        url: $(el2).attr('data-url'),
        type: $(el2).attr('data-method'),
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        data: formData,
        success: function (data) {
            if (data.status === true) {
                $('.map_list_result_count').html(data.total);
                if (el2.attr('data-scrollable') === 'true' && currentWidth >= 768) {
                    if (clearAll === true) {
                        $('.map_list_result').remove();
                    }
                    //el.mcs.content.append(data.html);
                    $('.fetching-properties').append(data.html);
                    console.log(forcePage);
                    if (forcePage === true) {
                        $("#mCSB_2_container").css("top", '0px');
                    }
                } else {
                    if (clearAll === true) {
                        $('.map_list_result').remove();
                    }
                    $('.fetching-properties').append(data.html);
                }
                window.loadMoreItemsProcessing = false;
                if (data.count === 0) {
                    window.infiniteScrollEnd = true;
                }
            }
        }
    })
}

$('#search_pickup').autocomplete({
    serviceUrl: $('#search_pickup').attr('data-url'),
    dataType: 'json'
});

$('#search_delivery').autocomplete({
    serviceUrl: $('#search_delivery').attr('data-url'),
    dataType: 'json'
});

$('#search_city').autocomplete({
    serviceUrl: $('#search_city').attr('data-url'),
    dataType: 'json',
    onSelect: function (suggestion) {
        getCoordinatesByCity(suggestion.value);
    }
});

function getCoordinatesByCity(city) {
    $.ajax({
        url: $('#homepage_city_input').attr('data-url'),
        type: $('#homepage_city_input').attr('data-method'),
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        data: {city: city},
        success: function (data) {
            $('#search_longitude').val(data.longitude);
            $('#search_latitude').val(data.latitude);
            $('#search-btn').click();
        }
    });
}

if (window.hasMap === false) {
    $('body').on('click', '#map-search-form button#search-btn', function () {
        window.infiniteScrollEnd = false;
        loadMoreItems($('.map-content-sidebar'), true, true);
    });
}

/* Search Saving */
$('body').on('click', '#saveSearchBtn', function () {
    let searchInfoHTML = '';

    $('body #filters-bar input, body #filters-bar textarea, body input.search-fields').each(function (i, v) {
        let elVal = $(v).val();
        let elName = $(v).attr('name');
        let elType = $(v).attr('type');

        searchInfoHTML = searchInfoHTML + "<input type='hidden' name='" + elName + "' value='" + elVal + "'/>";
        if ((elType !== 'hidden' || elName === 'min_price' || elName === 'max_price') && elName !== 'delivery' && elName !== 'pickup' && elName !== 'city') {
            let elTitle = $(v).attr('data-title');
            if (elName === 'min_price') {
                elTitle = 'Preço Mínimo';
            } else if (elName === 'max_price') {
                elTitle = 'Preço Máximo';
            }

            let content = '<li><b>' + elTitle + '</b>: ';

            if (elVal && elVal !== '') {
                content = content + elVal;
            } else {
                content = content + ' - ';
            }

            content = content + "</li>";

            searchInfoHTML = searchInfoHTML + content;
        }
    })

    $('body #filters-bar select').each(function (i, v) {
        let content = '<li><b>' + $(v).attr('data-title') + '</b>: ';
        let elVal = $(v).val();
        let elName = $(v).attr('name');

        searchInfoHTML = searchInfoHTML + "<input type='hidden' name='" + elName + "' value='" + elVal + "'/>";

        if (elVal && elVal !== '') {
            content = content + $("#" + $(v).attr('id') + " :selected").text();
        } else {
            content = content + ' - ';
        }

        content = content + "</li>";

        searchInfoHTML = searchInfoHTML + content;

    });

    $('#userSearchStoreFormBody ul#userSeachStoreFormInfo').html(searchInfoHTML);

    $('#userSearchStoreFormModal').modal('show');
});


$(window).load(function () {
    jQuery('[data-toggle="tooltip"]').tooltip({
        placement: 'top',
    })
})

$('body').on('click', '.help_button_header', function () {
    let el = $('.help_button_wrapper');
    let url = $(this).attr('data-url');
    let method = $(this).attr('data-method');

    let newStatus;
    if (el.hasClass('d-none')) {
        newStatus = 1;
    } else {
        newStatus = 0;
    }

    el.toggleClass('d-none');

    $.ajax({
        url: url,
        type: method,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        data: {status: newStatus},
        success: function (data) {
        }
    });
});
